import React from 'react';
import Divider from 'material-ui/Divider';
import PageBase from '../components/PageBase';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import {Helmet} from "react-helmet";

const Infantilak = () => {

  const styles = {
    images: {
      maxWidth: '100%'
    },
    filas: {
      textAlign: 'left'
    }
  };

  return (
    <PageBase title="Infantilak eta Katedetak"
              navigation="Oñatiko Duatloi Txikia / Infantilak eta Kadeteak">
        <Helmet>
          <title>Oñatiko Dutloi Txikia Infantilak</title>
          <meta name="description" content="Oñatiko duatloi txikiko infantil kategoriako zirkuituak" />
          <meta property="og:title" content="Oñatiko Dutloi Txikia Infantilak" />
          <meta property="og:description" content="Oñatiko duatloi txikiko infantil kategoriako zirkuituak" />
          <meta property="og:url" content="http://duatloitxikia.oinatikoduatloia.com/infantilak" />
          <meta property="og:image" content="http://duatloitxikia.oinatikoduatloia.com/infantilT1.png" />
      </Helmet>

        <Table>
          <Thead>
            <Tr>
              <Th style={styles.filas}>Ordua</Th>
              <Th style={styles.filas}>Sektorea</Th>
              <Th style={styles.filas}>Itzuli Kopurua</Th>
              <Th style={styles.filas}>Distantzia</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>11:30</Td>
              <Td>Korrika 1</Td>
              <Td>2 itzuli (bakoitza bere erritmoan)</Td>
              <Td>2000m</Td>
            </Tr>
            <Tr>
              <Td />
              <Td>Bizikleta</Td>
              <Td>2 itzuli (bakoitza bere erritmoan)</Td>
              <Td>7000m</Td>
            </Tr>
            <Tr>
              <Td />
              <Td>Korrika 2</Td>
              <Td>Itzuli 1 (bakoitza bere erritmoan)</Td>
              <Td>1000m</Td>
            </Tr>
          </Tbody>

        </Table>
      
        <Divider />

        <div className="row">
          <div className="col-md-12">
            <h3>T1 (Korrika)</h3>
            <center><img src={require('../images/infantilT1.png')} style={styles.images} /></center>

            <h3>T2 (Bizikleta)</h3>
            <center><img src={require('../images/infantilT2.png')} style={styles.images} /></center>

            <h3>T3 (Korrika)</h3>
            <center><img src={require('../images/infantilT3.png')} style={styles.images} /></center>
          </div>
        </div>



    </PageBase>
  );
};

export default Infantilak;



/** WEBPACK FOOTER **
 ** ./src/containers/Infantilak.js
 **/